module.exports = __webpack_public_path__ + "static/media/014f2daa-c310-4a36-b9fd-79a8e0c48d44.b67b4d9f.woff2";